export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve: any): void => {
    setTimeout(resolve, ms)
  })
}
